<template>
  <v-container>
    <v-dialog v-model="dialog" width="500">
      <v-btn slot="activator" color="red lighten-2" class="card-r " dark>Click Me</v-btn>
      <div class="div-cricle center">
        <v-icon class="mb-5 icon-size">fas fa-check-circle</v-icon>
      </div>
      <v-card class="card-pop">
        <v-layout align-center justify-center row fill-height>
          <v-flex>
            <div class="resultContainer width">
              <div class="text-xs-center" align-center>
                <v-flex xs12 class="p-colors mt-5 pt-5" offset-xs0>
                  <v-list>
                    <v-card class="mt-2">
                      <v-list-tile @click>
                        <v-list-tile-action>
                          <v-icon color="#0051a0">fas fa-check-circle</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>3 Packages</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-card>
                    <v-card class="mt-2">
                      <v-list-tile @click>
                        <v-list-tile-action>
                          <v-icon color="#0051a0">fas fa-check-circle</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>$450</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-card>
                  </v-list>
                </v-flex>
                <v-layout xs12>
                  <v-flex xs12 class="text-xs-right">
                    <v-btn class="btn-customer card-r">Confirm Booking</v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* eslint-disable */
export default {
  name: "AddCustomerSuccess"
};
</script>
<style >
.card-pop {
  z-index: -4;
  margin-top: -23%;
}
.width {
  width: 70%;
  margin-left: 15%;
}
.add-customer-click {
  width: 100%;
  height: 50%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.div-cricle {
  text-align: center;
  margin-top: 0%;
  z-index: 500;
  background-color: transparent !important;
}
.v-dialog {
  box-shadow: none !important;
}
.icon-size {
  font-size: 100px;
  color: #0051a0 !important;
  height: 100px;
  width: 100px;
  border-radius: 50%;
}
.tick-image {
  text-align: center;
  margin-top: 20%;
}
.font-size-cus {
  font-size: 50px;
  padding: 20px;
  font-weight: 100;
  width: 50%;
  height: 50%;
}
.p-color {
  color: #0080c2;
  font-size: 25px;
  font-weight: 700;
  width: 100%;
}
.p-colors {
  color: #000;
  font-size: 15px;
  font-weight: 700;
  opacity: 0.5;
  padding: 0px;
}
.p-size {
  text-align: center;
}
.btn-customer {
  width: 42%;
  background-color: #0051a0 !important;
  margin-bottom: 10%;
  color: #fff !important;
  margin-right: -1%;
}
.resultContainer .elevation-10 {
  border-radius: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmBooking.vue